export enum PushPlatform {
    Apple = 0,
    Android = 1,
}
